import React, { useState, FC } from "react";

import { useMatchParams } from "kanopi-components/hooks/useMatchParams";
import { quoteFlowFields } from "kw/api/fragments";
import {
  QuestionFlowComponent,
  QuestionFlowTypeEnum,
} from "kw/components/QuestionFlow/QuestionFlowComponent";
import { RouteComponentProps, useNavigate } from "@reach/router";
import { useGlobal } from "reactn";
import { toArray } from "kanopi-components/utils/primitives";
import { useTrackQuoteStarted } from "../hooks/useTracking";
import { QuoteState } from "kw/api/zeus";

type TQuoteFlowPageProps = {
  questionSetKey: string;
  isLegalPage: boolean;
};

export const QuoteFlowPage: FC<TQuoteFlowPageProps & RouteComponentProps> = ({
  isLegalPage = false,
  uri: prefix,
}) => {
  const { questionSetKey } = useMatchParams(`${prefix}/:questionSetKey`);
  const navigate = useNavigate();
  const [quotingData = {}] = useGlobal("quoting");
  const trackQuoteStarted = useTrackQuoteStarted();

  const startQuoteQuery = {
    startQuote: [
      {
        input: {
          questionSetKey,
          enabledProducts: toArray(quotingData?.enabledProducts),
          create: quotingData?.enabledProducts ? true : false,
          restart: quotingData?.restart,
        },
      },
      { ...quoteFlowFields },
    ],
  };
  const [currentMaxSet, setCurrentMaxSet] = useState({
    currentSet: 0,
    maxSets: 1,
  });

  React.useEffect(() => {
    const hostname = window.location.hostname;
    const parts = hostname.split(".");
    if (parts.length <= 2) {
      navigate("/404"); // Redirect to 404 page if no subdomain (denoting no org)
    }
  }, []);

  React.useEffect(() => {
    if (
      !!quotingData?.enquiry &&
      quotingData.currentSet == 0 &&
      quotingData.riskProfile.state === QuoteState.DRAFT
    ) {
      trackQuoteStarted({ riskProfile: quotingData.riskProfile });
    }
  }, [quotingData?.enquiry]);

  const onCurrentMaxSetChange = (currentSet, maxSets) => {
    const _totalSets = { ...currentMaxSet };
    _totalSets.currentSet = !questionSetKey && currentSet === maxSets ? 0 : currentSet;
    _totalSets.maxSets = maxSets;
    setCurrentMaxSet(_totalSets);
    if (
      !prefix.includes("quoting") &&
      !questionSetKey &&
      currentSet > 0 &&
      maxSets > 0 &&
      currentSet === maxSets
    ) {
      navigate("/quote/ready");
    } else if (!questionSetKey && currentSet === 0 && maxSets === 0) {
      navigate("/quote/referral");
    }
  };
  return (
    <QuestionFlowComponent
      isFlowLayout={!isLegalPage}
      actionFlowType={QuestionFlowTypeEnum.Quote}
      prefix={prefix}
      finishedRoute="/quote/ready"
      defaultBackLocation=""
      actionQuery={startQuoteQuery}
      questionFlowResponseKey="startQuote"
      questionSetKey={questionSetKey}
      steps={[
        {
          label: "Your details",
          active: true,
          current: currentMaxSet.currentSet,
          total: currentMaxSet.maxSets,
        },
        { label: "Your quote" },
        { label: "Review and buy" },
      ]}
      onCurrentAndMaxSetChange={onCurrentMaxSetChange}
    />
  );
};
